import { NgOptimizedImage } from "@angular/common";
import { Component, computed, input } from "@angular/core";
import { DirectusTranslationPipe } from "../../../../common/pipes/directus-translation.pipe";
import { GetDirectusImagePipe } from "../../../../common/pipes/get-directus-image.pipe";
import { PathFromItemPipe } from "../../../../common/pipes/path-from-item.pipe";
import { sanitizeDirectusArray, sanitizeDirectusObject } from "../../../../common/utils/sanitize-directus-object";
import { ItemsProductCategories } from "../../../api/packbo/models/items-product-categories";
import { ItemsProductCategoriesBlock } from "../../../api/packbo/models/items-product-categories-block";

@Component({
    selector: "packbo-product-categories-block",
    templateUrl: "./product-categories-block.template.html",
    imports: [DirectusTranslationPipe, PathFromItemPipe, GetDirectusImagePipe, NgOptimizedImage]
})
export class ProductCategoriesBlockComponent {
    public readonly productCategoriesBlock = input.required<ItemsProductCategoriesBlock>();

    public readonly categories = computed(() => {
        const categoriesRefs = this.productCategoriesBlock()?.categories_refs;
        if (!categoriesRefs) {
            return [];
        }

        return sanitizeDirectusArray(categoriesRefs)
            .map((item) => sanitizeDirectusObject(item.product_categories_id))
            .filter((category): category is ItemsProductCategories => category !== null);
    });
}
